import styled from "styled-components";
import { colors } from "../../../../../../theme/theme";

export const CardButton = styled.div`
    text-align: right;
    button { 
        color: ${colors.greyscale.white};
        background-color: transparent;
        border: 0px;
    }
`;

export const CardUnity = styled.div`
    background-color: ${colors.mainColors.white_lilac};
    padding: 7px 10px;
    color: ${colors.mainColors.blueberry};
    border-radius: 4px;
    border-left: 10px solid ${colors.mainColors.blueberry};

    button { 
        color: ${colors.mainColors.blueberry};
    }
`

export const CardDescription = styled.div`
    background-color: ${colors.greyscale.white};
    padding: 15px;
    height: 100%;
    color: ${colors.greyscale.darker_grey};
    border-radius: 8px;
    box-shadow: 1px 2px 4px rgba(51, 51, 51, 0.25);

    .title{
        font-weight: bold;
    }
`

